import apiClient from './api'

export interface SystemStatus {
  database: 'up' | 'down'
  status: 'ready' | 'degraded' | 'down'
  version: string
  environment: string
  responseTimeMs: number
  checkedAt: string
}

export interface DatabaseInfo {
  alembicVersion: string
  totalDeposits: number
  totalWithdrawals: number
  totalUsers: number
  lastUpdated: string
}

export interface DatabaseConnectionInfo {
  connection: {
    status: 'connected' | 'disconnected' | 'error'
    host: string
    port: number
    database: string
    user: string
    responseTimeMs: number
    error: string | null
  }
  data: {
    canRead: boolean
    totalDeposits: number
    totalWithdrawals: number
    totalChannels: number
    totalStatuses: number
    error: string | null
  }
  migration: {
    alembicVersion: string | null
  }
  checkedAt: string
}

export interface DatabaseStats {
  databaseSize?: string
  databaseSizeBytes?: number
  databaseSizeError?: string
  tables?: Array<{
    name: string
    totalSize: string
    totalSizeBytes: number
    tableSize: string
    indexesSize: string
  }>
  tablesError?: string
  connections?: {
    total: number
    active: number
    idle: number
    idleInTransaction: number
    max: number
  }
  connectionsError?: string
  locks?: {
    relationLocks: number
    tupleLocks: number
    exclusiveLocks: number
    waitingLocks: number
  }
  locksError?: string
  cacheHitRatio?: number
  cacheHitRatioError?: string
  checkedAt: string
}

export interface SlowQuery {
  query: string
  calls: number
  totalExecTime: number
  meanExecTime: number
  maxExecTime: number
  minExecTime: number
  stddevExecTime: number | null
}

export interface SlowQueriesInfo {
  available: boolean
  message?: string
  error?: string
  queries: SlowQuery[]
  checkedAt: string
}

export interface ErrorLogEntry {
  timestamp: string
  type: string
  message: string
  traceback?: string
  context?: {
    path?: string
    method?: string
    [key: string]: any
  }
}

export interface ErrorsInfo {
  errors: ErrorLogEntry[]
  total: number
  checkedAt: string
}

export const systemService = {
  fetchSystemStatus: () => apiClient.get('/system/readyz').then((res) => res.data),
  fetchDatabaseInfo: () => apiClient.get('/admin/database-info').then((res) => res.data).catch(() => null),
  fetchDatabaseConnection: (): Promise<DatabaseConnectionInfo> =>
    apiClient.get('/system/database').then((res) => res.data),
  fetchDatabaseStats: (): Promise<DatabaseStats> =>
    apiClient.get('/system/database/stats').then((res) => res.data),
  fetchSlowQueries: (): Promise<SlowQueriesInfo> =>
    apiClient.get('/system/database/slow-queries').then((res) => res.data),
  fetchErrors: (): Promise<ErrorsInfo> =>
    apiClient.get('/system/errors').then((res) => res.data),
}


